import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lifedi-require',
  templateUrl: './symbol-require.component.html',
  styleUrls: ['./symbol-require.component.scss']
})
export class SymbolRequireComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
